module.exports = new __parcel__URL__("Charlie_Text-Thin.342754ac.woff2").toString();